export enum ELoadingTexts {
  ProcessingPayment = 'PROCESSING PAYMENT',
  GetReadyToImagine = 'Get ready to imagine',
}